import { mockTheme } from './theme'

export const Mocks = {
  theme: mockTheme,
}